// Re-export from DataGridV2 (TanStack Table based) - replaces react-data-grid
export { DataGrid } from 'shared/components/DataGridV2';
export type {
  DataGridProps,
  DataGridFilters,
  DataGridFilter,
  DataGridSorting,
  Row,
  GridRow,
  GridDataRow,
  GridTitleRow,
  Column,
  ColumnFilter,
  ColumnType,
  IOption,
  SelectionState,
  GridRef,
  FormatterProps,
} from 'shared/components/DataGridV2';
export {
  convertDataTreeToGridRows,
  isGridDataRow,
  isGridTitleRow,
  getRowHeight,
  isAtBottom,
} from 'shared/components/DataGridV2';

// Legacy exports for backward compatibility
// These will be removed in future refactoring
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function baseCellWrapper(WrappedComponent: React.ComponentType<any>): React.ComponentType<any> {
  return (props: { value: unknown }) => {
    const { value } = props;
    if (value != null) {
      return <WrappedComponent value={value} />;
    }
    return <div>—</div>;
  };
}

export const BaseCell: React.FC<{ value?: unknown; children?: React.ReactNode }> = ({ value, children }) => {
  if (value != null) return <>{String(value)}</>;
  if (children != null) return <>{children}</>;
  return <span>—</span>;
};

// Legacy type re-exports (deprecated, use from DataGridV2 directly)
// These are kept for backward compatibility but not actively used
export type { TextColumnFilter, DateColumnFilter, MultiSelectColumnFilter } from 'shared/components/DataGridV2';
